import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBundleItems, StateStatus } from '@guryou/redux';
const useBundleItems = _ref => {
  let {
    id
  } = _ref;
  const dispatch = useDispatch();
  const {
    data,
    status,
    version,
    entity,
    request
  } = useSelector(state => state.bundle.getItems);
  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED || status === StateStatus.LOADED && request.id !== id) {
      dispatch(getBundleItems(id));
    }
  }, [data, dispatch, id, request, status]);
  return {
    data: data || [],
    status,
    version,
    entity
  };
};
export default useBundleItems;